import React, { useState, createContext } from 'react';
import axios from 'axios';
import { getStorageKey, setStorageKey } from '../core/utils/storage';

export const TYPE_FAVOURITE_LISTINGS = 'favourites';
export const TYPE_FAVOURITE_PRODUCTS = 'favourite-products';

export const FavouritesContext = createContext()

const FavouritesContextProvider = (props) => {
    const getCollection = type => type === 'favourites' ? 'listings' : 'products';

    const syncFavourites = async (type = 'favourites') => {
        const collection = getCollection(type);

        setContext({...context});

        if (axios.defaults.headers.common['Authorization']) {
            await axios.put('/api/lists', {
                type,
                items: context[collection].map(function (item) {
                    return {
                        'listable_id': item.id,
                    }
                }),
            });
        }

        setStorageKey(type, JSON.stringify(context[collection]));
    }

    const addToFavourites = (item, type = TYPE_FAVOURITE_LISTINGS) => {
        // A double click lands before the star re-renders as "starred", so
        // the second add must not push the same item again.
        if (findInFavourites(item, type)) {
            return;
        }
        context[getCollection(type)].push(item);

        syncFavourites(type);
    }

    const findInFavourites = (item, type = TYPE_FAVOURITE_LISTINGS) => {
        return context[getCollection(type)].find(el => el.id === item.id)
    }

    const removeFromFavourites = (item, type = TYPE_FAVOURITE_LISTINGS) => {
        const collection = getCollection(type);
        context[collection] = context[collection].filter(
            (el) => el.id !== item.id
        );

        syncFavourites(type);
    }

    const [context, setContext] = useState({
        add: (item, type) => addToFavourites(item, type),
        find: (item, type) => findInFavourites(item, type),
        remove: (item, type) => removeFromFavourites(item, type),
        listings: JSON.parse(getStorageKey(TYPE_FAVOURITE_LISTINGS)) || [],
        products: JSON.parse(getStorageKey(TYPE_FAVOURITE_PRODUCTS)) || [],
    });

    return (
        <FavouritesContext.Provider value={context}>
            {props.children}
        </FavouritesContext.Provider>
    )
}

export default FavouritesContextProvider;
